<template>

<app-panel v-on:close="$emit('close')" :loading="is.loading">
		
	<app-panel-title text="Issue credit" />

    <app-panel-text>

        <p>You can issue credit in USD to a convention which will be immediately applied to their current billing status. The credit can also be retracted at a later date if needed.</p>

    </app-panel-text>

    <app-panel-content>

        <app-input-text label="Amount" v-model="model.amount" prefix="$" placeholder="0.00" />

		<app-input-text label="Title" :maxlength="64" v-model="model.title" :stacked="true" placeholder="Enter short reason or code" />

		<app-input-text label="Message" :autogrow="true" v-model="model.message" :stacked="true" placeholder="Enter optional message to be included with e-mailed receipt to convention owner." />

	</app-panel-content>

	<app-panel-content>

		<app-button text="Confirm" :disabled="!isValid" :loading="is.saving" v-on:click="onConfirmClick" />

	</app-panel-content>

</app-panel>

</template>

<script>

export default {
	
	props: ['id'],

	data: function() {

		return {
			is: {
				loading: false,
                saving: false
			},
			model: {
				message: '',
				title: '',
				amount: ''
			}
		}

	},

	computed: {
	
		isValid: function() {
		
			return this.model.amount > 0 && this.model.title

		}

	},

	methods: {

		onConfirmClick: async function() {

			if(!this.isValid) return false

			this.is.saving = true

			this.$api.post(['conventions/convention', this.id, 'credit'], this.model).then(function() {

				this.is.saving = false

				this.$notify({
					message: ['You have successfully issued credit.']
				})

				this.$emit('credited')

				this.$emit('close')

			}.bind(this), function() {
			
				this.is.saving = false

				this.$notify({
					type: 'error',
					message: ['Sorry, the credit could not be issued.']
				})
			
			}.bind(this))

		}

	}

}

</script>

<style scoped>

</style>
